import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import Services from "./pages/Services";
import InfraMonitoring from "./pages/InfraMonitoring";
import Card from "./pages/Card";
import Reel from "./pages/Reel";
import BrandKit from "./pages/BrandKit";
import AdminLogin from "./pages/AdminLogin";
import AdminDirectors from "./pages/AdminDirectors";
import { AuthProvider } from "./context/AuthContext";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/it-infrastructure-monitoring" element={<InfraMonitoring />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
            </Route>
            <Route path="/card/:slug" element={<Card />} />
            <Route path="/reel" element={<Reel />} />
            <Route path="/brand-kit" element={<BrandKit />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDirectors />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0D",
            border: "1px solid rgba(0,240,255,0.3)",
            borderRadius: 0,
            color: "#fff",
            fontFamily: "'IBM Plex Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
